export default {
    
    show_raw_data_modal_title: "Raw data",
    show_raw_data_modal_cancel: "Cancel",
    show_raw_data_modal_copy: "Copy",
    show_raw_data_modal_copied: "Copied",
    
  };
  
  
  
  
  
  
  
  